/*--------------------------------------
                  HEDAER
 --------------------------------------*/

mobileMenu = {
    init: function () {
        // OPEN
        $(".header__mobile-menu-btn").on("click", function (e) {
            e.preventDefault();
            $("body").toggleClass("open--mobile-menu");
        });

        // CLOSE
        $(".mobile-menu__head__close").on("click", function (e) {
            e.preventDefault();
            $("body").toggleClass("open--mobile-menu");
        });

        // CLOSE
        $("body").on("click", function (event) {
            if (!$(event.target).closest('.header__mobile-menu-btn, .section-mobile-menu').length) {
                $("body").removeClass("open--mobile-menu");
            }
        });
    }
};

langMenu = {
    init: function () {
        $(".lang-selector").on("click", function (e) {
            e.preventDefault();
            $(this).toggleClass("open");
        });

        $("body").on("click", function (event) {
            if (!$(event.target).closest('.lang-selector').length) {
                $(".lang-selector").removeClass("open");
            }
        });
    }
};

/*--------------------------------------
                 OTHERS 
 --------------------------------------*/
dynamicViewHeight = {
    init: function () {
        function updateViewHeight() {
            const vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty('--vh', `${vh}px`);
        }

        updateViewHeight();

        window.addEventListener('resize', updateViewHeight);
        window.addEventListener('orientationchange', updateViewHeight);
    }
};

scrollToSSLL = {
    init: function () {
        /** Scroll to a part of the page by classname or by pixel number
        *  -  href="website.com/?scrollto=classname"   ==>  Loads new page and scroll to div with class 'classname'
        *  -  href="scrollto:classname"                ==>  Scrolls to div with class 'classname'
        *  -  href="scrollto:next"                     ==>  Scrolls to next section with class 'block'
        *  -  href="scrollto:0"                        ==>  Scrolls to pixel 0 (top of page)
        *
        * by Lluc  :)
        **/


        /*  --  CLICK LINK  --  */
        $('a[href^="scrollto:"]').on('click', function (e) {
            $("body").removeClass('menu--open');
            e.preventDefault();
            history.pushState(null, null, ' ');

            var btn = $(this);
            var target = $(this).attr('href').split(':')[1];

            scroll(btn, target)
        });


        /*  --  PAGE LOAD  --  */
        var params = getQueryStringParameters(window.location.href);
        if (params['scrollto']) {
            var target = params['scrollto'];
            scroll(null, target);
            removeQueryParam('scrollto', window.location.href);
        }


        /*  --  FUNCTIOMS  --  */

        function scroll(btn, target) {
            if (target == 'next') {
                // Find the next .block element in the document after the current one (regardless of nesting)
                var currentBlock = btn.closest('.block')[0];
                var allBlocks = Array.from(document.querySelectorAll('.block'));
                var curIndex = allBlocks.indexOf(currentBlock);
                var nextSection = (curIndex !== -1 && curIndex < allBlocks.length - 1) ? $(allBlocks[curIndex + 1]) : $();

                if (nextSection.length) {
                    $('html, body').animate({
                        scrollTop: $(nextSection).offset().top
                    }, 800);
                }

            } else if ($('.' + target).length) {
                $('html, body').animate({
                    scrollTop: $('.' + target).offset().top
                }, 800);

            } else if (isNumber(target)) {
                $('html, body').animate({
                    scrollTop: target
                }, 800);
            }
        }

        function isNumber(n) {
            return !isNaN(parseFloat(n)) && isFinite(n);
        }

        function getQueryStringParameters(url) {
            var params = {};
            var parser = document.createElement('a');
            parser.href = url;
            var query = parser.search.substring(1);
            var vars = query.split('&');
            for (var i = 0; i < vars.length; i++) {
                var pair = vars[i].split('=');
                params[pair[0]] = decodeURIComponent(pair[1]);
            }
            return params;
        }

        function removeQueryParam(param, url) {
            var urlObj = new URL(url);
            urlObj.searchParams.delete(param);
            window.history.pushState({}, '', urlObj.href);
        }
    }
};

animations = {
    init: function () {
        var controller = new ScrollMagic.Controller();
        //FADEINUP
        $('[data-fadeinup]').each(function () {
            var tw = new gsap.timeline();
            tw.from(this, 1.7, { ease: Expo.easeOut, y: 20 })
                .to(this, 1, { opacity: 1 }, 0);

            var scene = new ScrollMagic.Scene({
                triggerElement: this,
                triggerHook: .92,
                reverse: true
            })
                .setTween(tw)
                //.addIndicators()
                .addTo(controller);
        });

        //FADEIN
        $('[data-fadein]').each(function () {
            var tw = new gsap.timeline();
            tw.to(this, 1, { opacity: 1 });

            var scene = new ScrollMagic.Scene({
                triggerElement: this,
                triggerHook: 1,
                reverse: true
            })
                .setTween(tw)
                //.addIndicators()
                .addTo(controller);
        });


    }
};

pngToSvg = {
    init: function () {
        jQuery('img.svg').each(function () {
            var $img = jQuery(this);
            var imgID = $img.attr('id');
            var imgClass = $img.attr('class');
            var imgURL = $img.attr('src');

            jQuery.get(imgURL, function (data) {
                // Get the SVG tag, ignore the rest
                var $svg = jQuery(data).find('svg');

                // Add replaced image's ID to the new SVG
                if (typeof imgID !== 'undefined') {
                    $svg = $svg.attr('id', imgID);
                }
                // Add replaced image's classes to the new SVG
                if (typeof imgClass !== 'undefined') {
                    $svg = $svg.attr('class', imgClass + ' replaced-svg');
                }

                // Remove any invalid XML tags as per http://validator.w3.org
                $svg = $svg.removeAttr('xmlns:a');

                // Replace image with new SVG
                $img.replaceWith($svg);

            }, 'xml');
        });
    }
};

pageHero = {
    init: function () {
        if ($(".page-hero").length > 0) {
            $("body").addClass("page-hero");
        }
    },
};

$(document).ready(function () {
    // HEADER
    mobileMenu.init();
    langMenu.init();

    // OTHERS
    dynamicViewHeight.init();
    scrollToSSLL.init();
    animations.init();
    pngToSvg.init();
    pageHero.init();
});